export default __webpack_public_path__ + "static/media/path-finding-phone-googlemap.9e3a7f87.webp";